import claimSaga from 'Agent/Claims/sagas/claimSaga';
import {all} from 'redux-saga/effects';

export default function*() {
  yield all([claimSaga()]);
}
